import React, { useCallback, useRef } from 'react';
import { ReactComponent as ActionAddOutlineIcon } from '@epam/assets/icons/action-add-outline.svg';
import { ReactComponent as ContentMinusOutlineIcon } from '@epam/assets/icons/content-minus-outline.svg';

import numericInputCss from './NumericInput.module.scss';
import formBodyCss from '../FormBody.module.scss';
import { NumericInputProps } from './NumericInput.model';
import { IconButton, NumericInput } from '@epam/promo';

const MIN_COMPLETED_TASK_VALUE = 0;
const MAX_COMPLETED_TASK_VALUE = 999;

export const NumericInputCustom = ({
  value,
  handleChange,
  hasError,
  onBlur,
}: NumericInputProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const onChange = useCallback(
    (newValue: number) => {
      if (
        newValue >= MIN_COMPLETED_TASK_VALUE &&
        newValue <= MAX_COMPLETED_TASK_VALUE
      ) {
        handleChange(newValue ? newValue.toString() : '');
      }
    },
    [handleChange],
  );

  const onClick = useCallback(
    (newValue: number) => {
      inputRef.current?.focus();
      onChange(newValue);
    },
    [onChange],
  );

  return (
    <div className={numericInputCss['input-wrapper']}>
      <IconButton
        icon={ContentMinusOutlineIcon}
        isDisabled={Number(value) <= MIN_COMPLETED_TASK_VALUE}
        onClick={() => onClick((+value || 0) - 1)}
      />
      <NumericInput
        ref={inputRef}
        align="center"
        cx={{
          [formBodyCss.textarea__input]: true,
          [formBodyCss['textarea__input--error']]: hasError,
          [numericInputCss['input-wrapper__input']]: true,
        }}
        disableArrows={true}
        isInvalid={hasError}
        max={MAX_COMPLETED_TASK_VALUE}
        min={MIN_COMPLETED_TASK_VALUE}
        mode="form"
        placeholder="Comleted tasks"
        rawProps={{ 'data-testid': 'completed-tasks-input' }}
        size="48"
        value={value}
        onBlur={(e) => onBlur(e.target.value)}
        onValueChange={onChange}
      />
      <IconButton
        icon={ActionAddOutlineIcon}
        onClick={() => onClick((+value || 0) + 1)}
      />
    </div>
  );
};
